/**
 * Single Post
 */

class Kevinlearynet_Post {
  constructor() {
    this.nestedLists();
  }

  nestedLists() {
    const $lists = $(".post__content > ul:contains(ul), .post__content > ol:contains(ol)");
    if (!$lists.length) return;

    $lists.addClass("nested-list").find("> li > ul, > li > ol").parent().addClass("nested-list__parent-item");
  }
}

new Kevinlearynet_Post();
